import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class UserLoadAlertService {
  constructor(private http: HttpClient) {}
  // ton apis
  getUserAlerts(data: any) {
    return this.http.get(
      environment.apiUrl + `user/alerts?page=${data.page}&limit=${data.limit}`,
    );
  }
}
